import { render, staticRenderFns } from "./ybStateSwitch.vue?vue&type=template&id=5182619f&scoped=true&"
import script from "./ybStateSwitch.vue?vue&type=script&lang=js&"
export * from "./ybStateSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5182619f",
  null
  
)

export default component.exports